import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";

import { faFileArrowDown, faTrash } from "@fortawesome/pro-regular-svg-icons";
import { resetPreviewPackingList, reviewPackingList, updatePackingListStep } from "../../../actions/PackingList/actions";

import { UserRole } from "../../../actions/Tenants/config/constantsTyped";

import useAuthorization from "../../../utils/authorization";
import { Button } from "../../Helper/Button";
import { STEPS } from "./PackingListUploadModal";
import WrappedPreviewPackingList from "./PreviewPackingList";
import useEnrichPreviewHook from "./useEnrichPreviewHook";

interface PackingListReviewModalProps {
    list_id: string | boolean;
    isOpen: boolean;
    toggle: () => void;
    download: (list_id: string) => void;
    onDelete: (list_id: string) => void;
}
export default function PackingListReviewModal({ list_id, isOpen, toggle, download, onDelete }: PackingListReviewModalProps) {
    const dispatch = useDispatch();
    const step = useSelector((state: any) => state.packingLists.step);
    const import_data = useSelector((state: any) => state.packingLists.import_data);
    const isLoading = useSelector((state: any) => state.packingLists.isLoading);
    const isUpating = useSelector((state: any) => state.packingLists.isUpdating);
    const user = useSelector((state: any) => state.auth.user);
    const auth = useAuthorization();

    useEnrichPreviewHook();


    const cancel = () => {
        dispatch(resetPreviewPackingList() as any);
        toggle();
    };

    useEffect(() => {
        dispatch(resetPreviewPackingList() as any);
        if (list_id) {
            dispatch(reviewPackingList(list_id)as any);
        }
    }, [list_id]);


    return (
        <Modal fullscreen={true} isOpen={isOpen} toggle={() => cancel()} >
            <ModalHeader toggle={() => cancel()} >View packing list</ModalHeader>
            <ModalBody>
                <WrappedPreviewPackingList />
            </ModalBody>
            <ModalFooter>

                <Button color="light" icon={faFileArrowDown} onClick={() => download(list_id as string)}>Download</Button>
                {(user.is_admin || auth.userHasRole(UserRole.TENANT_ADMIN)) && (
                    <Button color="danger" icon={faTrash} onClick={() => onDelete(list_id as string)}>Delete</Button>
                )}
                <span className="mx-auto"></span>

                <Button color="light" onClick={() => cancel()}>Cancel</Button>
                {step === STEPS.PICK_FILE_AND_REVIEW_CONTEXT && import_data && <Button color="primary" disabled={ isLoading || isUpating || !import_data} onClick={() => dispatch(updatePackingListStep(STEPS.REVIEW_CHILDS_AND_IMPORT))}>Next</Button>}
                {step === STEPS.REVIEW_CHILDS_AND_IMPORT && <Button color="light" onClick={() => dispatch(updatePackingListStep(STEPS.PICK_FILE_AND_REVIEW_CONTEXT))}>Back</Button>}
            </ModalFooter>
        </Modal>


    );
}
